import { useEffect, useRef } from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { ChartColumnIcon } from '@hugeicons/core-free-icons';
import { ComingSoon } from '../components/shared/ComingSoon';
import { capture } from '../lib/analytics';

export function ReportsPage() {
  // Fire the page-view once on mount (mirrors billing_page_viewed).
  const viewedRef = useRef(false);
  useEffect(() => {
    if (viewedRef.current) return;
    viewedRef.current = true;
    capture('reports_page_viewed');
  }, []);

  return (
    <section id="reports" className="page-content">
      <div className="page-content__inner">
        <ComingSoon
          icon={<HugeiconsIcon icon={ChartColumnIcon} size={24} strokeWidth={2} color="currentColor" />}
          description="Exportable QA reports and analytics are on the way."
        />
      </div>
    </section>
  );
}
